import { render, staticRenderFns } from "./Police.vue?vue&type=template&id=76b1a084&scoped=true&"
import script from "./Police.vue?vue&type=script&lang=js&"
export * from "./Police.vue?vue&type=script&lang=js&"
import style0 from "./Police.vue?vue&type=style&index=0&id=76b1a084&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76b1a084",
  null
  
)

export default component.exports